<div class="export-controls export-ignore" [ngClass]="wrapperClass">
    <button *ngIf="!isExporting"
            type="button"
            mat-icon-button
            class="export-btn export-ignore"
            [ngClass]="buttonClass"
            [matTooltip]="tooltip"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel || tooltip"
            (click)="onClick($event)">
        <mat-icon>{{ icon }}</mat-icon>
    </button>
    <mat-progress-spinner *ngIf="isExporting"
                          class="export-spinner export-ignore"
                          mode="indeterminate"
                          [diameter]="spinnerDiameter"
                          [strokeWidth]="spinnerStrokeWidth">
    </mat-progress-spinner>
</div>

